
//popup kit
$(document).ready(function() {
	//console.log(detailsKit);
	//console.log(productsCart);

	// Agregar boton falso para poder chekar la seleccion multiple
	setTimeout(() => {
	if($('.cbb-frequently-bought-form').length) {

		let btn = document.createElement('span');
			btn.className = 'cbb-frequently-bought-add-button';
				$('.cbb-frequently-bought-form').append(
					`<span id="multiple-add" class="cbb-frequently-bought-add-button custom">
						<span class="translatable">Add selected to cart</span>
					</span>
				`);
			}else{
				//console.log('btn no existe');
			}
	}, 4000);

	//detectando click en boton falso para tomar los valores que se revisaran
	$(document).on('click', '#multiple-add', (e)=> {
		let multipleItems = [];
		$(e.currentTarget).parents('.cbb-frequently-bought-container').find('input[type="checkbox"]').each(function () { 
	
			if($(this).is(':checked')){
				multipleItems.push($(this).attr('id'));
			}

			if(multipleItems.length) {
				localStorage.setItem('smg-popup-multiple', JSON.stringify(multipleItems));
			}

			$('button.cbb-frequently-bought-add-button').trigger('click');
		});
	});

	//almacenar id de select modificado en cart para guardar en el storage
	let checkChange = (e) => {
		let quantity = $(e.currentTarget).val();;
		let id = $(e.currentTarget).parents('.cart-item').data('cartitem-id');
		let smgPopup = {'isActive': true, 'quantity': quantity, 'id': id}
		localStorage.setItem('smg-popup', JSON.stringify(smgPopup));
	}

	//detectar cambio en select del cart
	$('.cart-listener').on('change', (e)=> {
		checkChange(e);
	});

	//detectar al eliminar un item
	$('.cart-item--remove').on('click', (e)=> {
		checkChange(e);
	});


	$(document).on('click', '.popup-kit-close', function() { 				//cerrar popup
		$(this).parents('.popup-creepy-kit').fadeOut();
	});

	function updatePopup(tag) {
		//console.log(detailsKit);
		
		detailsKit.forEach(obj => {
			
			if(obj.currentItem > 0) {
				let remainingItems = obj.maximumItems - obj.currentItem;
				let porcentageWidth = 100 / obj.maximumItems;
				let elements = [];
				let styleSuccess = (remainingItems <= 0) ? 'barSuccess' : '';
				let popupText = obj.popupText.replace(/\[Y\]/g, `<span class="tag-product">${obj.tag}</span>`);
					popupText = popupText.replace(/\[X\]/g, `${remainingItems}`);
				let textModal = (remainingItems > 0) ? popupText : obj.PopupTextSuccess;
				let tagName = obj.tag.replace(/ /g,'').toLowerCase();
				let tagClass= `tags-${tagName}`;
	
				for (let idx = 1; idx <= obj.maximumItems; idx++) {
					elements.push(`<span class="item-rule" style="width: ${porcentageWidth}% ">${idx}</span>`);
				}
				
				if(!$(`.${tagClass}`).length && tagName == tag) {
					
					$(`#container-popup-kit`).append(`
						<div class="popup-creepy-kit animated bounceInRight ${tagClass}">
							<div class="popup-header">
								<span class="popup-kit-close close">
									<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="times" role="img"
										xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x">
										<path fill="currentColor"
											d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
											class=""></path>
									</svg>
								</span>
							</div>
							<div class="popup-body">
								<img class="img-presentation" src="//creepycompany.com/cdn/shop/t/361/assets/img-popup.png?v=43298761214509204331785169925">
								<span class="title">Build a Creepy Kit</span>
								<p class="info">${textModal}</p>
								<div class="area-load">
									<div class="loading">
										<div class="fill-loading ${styleSuccess}" style="width: ${obj.currentItem * porcentageWidth}%; max-width: 100%"></div>
									</div>
									<div class="rule">
										${elements.join(' ')}
									</div>
								</div>
								<a href="#" class="view-all-kit-offers">View All Kit Offers</a>
							</div>
						</div>
					`);
				}	else if (tagName == tag){
					$(`.${tagClass}`).css('display', 'block');
					$(`.${tagClass}`).find('.info').html(textModal);
					$(`.${tagClass}`).find('.fill-loading').css('width', `${obj.currentItem * porcentageWidth}%`);
					
					if(remainingItems <= 0) {
						$(`.${tagClass}`).find('.fill-loading').addClass('barSuccess');
					}else {
						$(`.${tagClass}`).find('.fill-loading').removeClass('barSuccess');
					}
				}
			}
			
		});
	}

	function compareRules(id, quantity) {									//funcion para ver las reglas y los productos de tags señalados
		//console.log(id)
		//console.log(quantity)
		$.getJSON( "/cart.js", function( response ) {
			let itemsCart = [];
			response.items.forEach(cart => {
				let bundle = (cart.properties.hasOwnProperty('_bundle-product') && cart.properties['_bundle-product'])
				//console.log(bundle);
				if(!bundle) {
					itemsCart.push({'handle':cart.handle, 'quantity': cart.quantity, 'variant': cart.variant_id});
				}
			});
			//console.log(itemsCart)
			detailsKit.forEach(settings => {
				//console.log(settings.tag)
				let desiredTag = settings.tag;
				settings.currentItem = 0;
				itemsCart.forEach(cartHandle => {
					//console.error(productsCart[cartHandle]);
					
					let tagsProduct = productsCart[cartHandle.handle];
						tagsProduct = tagsProduct.join().toLowerCase().replace(/ /g,'').split(',');
						desiredTag = desiredTag.toLowerCase().replace(/ /g,'');

					if(tagsProduct.indexOf(desiredTag) >= 0) {
						settings.currentItem += cartHandle.quantity;
						//console.log('consiguio el tags' + desiredTag + 'en el producto' + handle);
					}
				});
				
				//console.log(variantsProducts);
				let stringVariants = variantsProducts[id];
					stringVariants = stringVariants.join().toLowerCase().replace(/ /g,'').split(',');

				if(stringVariants.indexOf(desiredTag) >= 0) {
					updatePopup(desiredTag);
				}
			});

		
		});
	}

	if(detailsKit.length) {		//comprobar si hay configuracion establecida
		//compareRules(19441353326659);
		// Obtengo el string del storaje
		
		if(localStorage.getItem('smg-popup')){
			let data = JSON.parse(localStorage.getItem('smg-popup'));
			compareRules(data.id, data.quantity);
			localStorage.removeItem('smg-popup');
		}

		if(localStorage.getItem('smg-popup-multiple')){
			let data = JSON.parse(localStorage.getItem('smg-popup-multiple'));
			data.forEach(element => {
				compareRules(element, 1);
			});
			localStorage.removeItem('smg-popup-multiple');
		}

		$(document).ajaxComplete(function( event, xhr, settings ) {
			//console.error(settings.url)
			if (    typeof(settings) != 'undefined' &&
					(settings.url === "/cart/add.js" /*||
					settings.url === "/cart/change" ||
					settings.url === "/cart/update.js" ||
					settings.url === "/cart/clear.js"*/)
				 ) {

				const urlParams = new URLSearchParams(settings.data);
				const id = urlParams.get('id');
				const quantity = urlParams.get('quantity');

				compareRules(id, quantity);
			}
		});

	}else {
		console.error('Popup has no rules for set gift');
	}
});